<script type="text/javascript">
  // Listed Simply site review
  export default {
    props: ['website'],
    data() {
      return {
        title: 'Listed Simply',
        url: 'https://www.listedsimply.com/arizona/',
        updated: '9/18/2023',

        pages: [
          // ========== START OF PAGE ==========
          {
            title: 'HOME',
            main: 1,
            url: `https://www.listedsimply.com/arizona/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Flat Fee MLS Listing $79 - No Agents | No Listing Commissions`,
            meta_desc: `Save thousands by listing your home on the MLS for a one-time flat fee of $79. Pay $0 in commissions. Manage your Arizona listing online.`,
            h1: [
              `$59 MLS Only Listing`,
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `Simple, Easy and all online.`,
              `$79 $79 MLS Listing`,
              `$79 $79`,
              `$279 $279`,
              `Find Out If We Service Your Area`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'MLS + Photos',
            main: 1,
            url: `https://www.listedsimply.com/mls-plus-plan/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Professional Real Estate Photography - Listed Simply`,
            meta_desc: `List your home on the MLS with professional real estate photography. Our photographers can come to your home as soon as the next day.`,
            h1: [
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `30 HD Professional Photos`,
              `MLS Plus Photos $279 $279`,
              `$79 $79`,
              `$279 $279`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'MLS + Paperwork',
            main: 1,
            url: `https://www.listedsimply.com/mls-paperwork/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `MLS + Paperwork - Listed Simply`,
            meta_desc: `We'll list your home on the MLS and manage your transaction. Receive complimentary professional photography, advertising, pricing strategy, and listing review.`,
            h1: [
              `MLS + Paperwork`,
              `WHAT'S THE COST`,
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `$0 Up Front, Flat Fee Paid At Closing`,
              `You show your home, We'll handle the paperwork Dedicated Contract Experts on Your Side 7 Days A Week`,
              `Seller's Net Sheet Calculator`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `23 H2 tags with property addresses`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Pricing',
            main: 1,
            url: `https://www.listedsimply.com/pricing/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Listed Simply - Flat Fee MLS Pricing`,
            meta_desc: `List your home on the MLS for only $79. Your listing will be syndicated to over 100 major real estate sites such as Zillow, Redfin, Trulia, and many more.`,
            h1: [
              `WHAT'S THE COST`,
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `$79 $79`,
              `$279 $279`,
              `Seller's Net Sheet Calculator`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `Find Out If We Service Your Area`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Do You Service My Area',
            main: 1,
            url: `https://www.listedsimply.com/mls-search/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `MLS Search - Listed Simply`,
            meta_desc: ``,
            h1: [
              `Search for my Local MLS`,
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `$79 $79`,
              `$279 $279`,
              `$79 $59`,
              `$279 $259`,
              `$469 $449`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
              `Prepare For Your Photography Shoot`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Resources',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Blog',
                main: 1,
                url: `https://blog.listedsimply.com`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Listed Simply Blog -`,
                meta_desc: ``,
                h1: [
                  ``,
                ],
                h2: [
                  `Plenty of Buyers Are Still Active Today [INFOGRAPHIC]`,
                  `Why Is Housing Inventory So Low?`,
                  `Should Baby Boomers Buy or Rent After Selling Their Houses?`,
                  `What Experts Project for Home Prices Over the Next 5 Years`,
                  `Planning to Retire? Your Equity Can Help You Make a Move`,
                  `Home Price Forecasts Revised for 2023 [INFOGRAPHIC]`,
                  `Get Ready for Smaller, More Affordable Homes`,
                  `Mortgage Rates: Past, Present, and Possible Future`,
                  `Expert Home Price Forecasts Revised Up for 2023`,
                  `Why It's Still a Seller's Market Today`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Knowledge Center',
                main: 1,
                url: `https://www.listedsimply.com/knowledge-center/`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Listed Simply - Knowledge Center`,
                meta_desc: `Knowledge based on how to sell your home. If you require changes to your listing, simply let the our team know and they happily to assist you!`,
                h1: [
                  `Seller's Net Sheet Calculator`,
                ],
                h2: [
                  `Ownership Types`,
                  `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
                  `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
                  `You save $5,625`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Additional Services',
                main: 1,
                url: `https://www.listedsimply.com/our-services/`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Our Services - Listed Simply`,
                meta_desc: ``,
                h1: [
                  ``,
                  `Seller's Net Sheet Calculator`,
                  `Seller's Net Sheet Calculator`,
                ],
                h2: [
                  `Additional Services`,
                  `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
                  `You save $5,625`,
                  ``,
                  `Ownership Types`,
                  `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
                  `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
                  `You save`,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Create a Listing',
            main: 1,
            url: `https://www.listedsimply.com/create-listing/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Dedicated Licensed Agent - Listed Simply`,
            meta_desc: ``,
            h1: [
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Transaction Management Service',
            main: 0,
            url: `https://www.listedsimply.com/professionally-managed-escrow`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Transaction Management - Listed Simply`,
            meta_desc: `Once you start to receive offers on your property, Listed Simply's legal department can review your offers and let you know of any red flags.`,
            h1: [
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `Professional Transaction Management`,
              `30 H2 tags with property addresses`,
              `See how much you'll save compared to using a traditional agent to manage your transaction`,
              `You save $5,625`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Our Listings',
            main: 0,
            url: `https://www.listedsimply.com/listings/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Listings - Listed Simply`,
            meta_desc: `Find homes listed for sale by owner on Listed Simply. List your home on the MLS for a flat fee of $79 and pay $0 in agent listing commissions.`,
            h1: [
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `10 H2 tags with property addresses`,
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Privacy Policy',
            main: 0,
            url: `https://www.listedsimply.com/privacy-policy`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Privacy Policy - Listed Simply`,
            meta_desc: `Welcome to Listed Simply Inc. (“Listed Simply”), a technology-powered online real estate brokerage. By accessing or using the Listed Simply websites...`,
            h1: [
              `Privacy Policy`,
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Terms Of Use',
            main: 0,
            url: `https://www.listedsimply.com/terms-and-conditions/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Terms and Conditions - Listed Simply`,
            meta_desc: `Welcome to Listed Simply Inc. (“Listed Simply”), a technology-powered online real estate brokerage. By accessing or using the Listed Simply websites...`,
            h1: [
              `Terms and Conditions`,
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Refunds & Cancellations',
            main: 0,
            url: `https://www.listedsimply.com/refunds-and-cancellations`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Refunds and Cancellations - Listed Simply`,
            meta_desc: ``,
            h1: [
              `Seller's Net Sheet Calculator`,
            ],
            h2: [
              `Ownership Types`,
              `Find Out The Cost To Use Our Transaction Management Service & Get A Dedicated Contract Expert On Your Side.`,
              `See How Much You'll Save Compared To Using A Traditional Agent To Manage Your Transaction`,
              `You save $5,625`,
            ]
          },

        ],

      }
    },
    computed: {
      compPages: function() {
        var output = [];
        for(var i in this.pages) {
          var temp = JSON.parse(JSON.stringify(this.pages[i]));
          if(temp['children']) { delete temp['children']; }
          output.push(temp);
          if(this.pages[i]['children']) {
            for(var j in this.pages[i]['children']) {
              var temp = JSON.parse(JSON.stringify(this.pages[i]['children'][j]));
              if(temp['children']) { delete temp['children']; }
              output.push(temp);
            }
          }
        }
        return output;
      },
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} navigation</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <h4 class="_underline">Site info</h4>
            <div class="mb-5">
              <div class=""><strong>Company :</strong> {{title}}</div>
              <div class=""><strong>URL :</strong> {{url}}</div>
              <div class=""><strong>Last updated :</strong> {{updated}}</div>

            </div>
            <h4 class="_underline">Main navigation</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="item['main']">
                <div class="font-weight-bolder">{{item['title']}}</div>
                <ul class="pl-5 m-0">
                  <li v-for="(sub1, sub1_i) in item['children']" :key="sub1_i">
                    {{sub1['title']}}
                    <ul class="pl-5 m-0">
                      <li v-for="(sub2, sub2_i) in sub1['children']" :key="sub2_i">
                        {{sub2['title']}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
            <h4 class="mt-5 _underline">Additional pages</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="!item['main']">{{item['title']}}</li>
            </ul>
          </div>



        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} page content</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s website content and SEO basics. Scroll through the table vertically and horizontally with the mouse wheel.</p>
          </div>

          <div class="table-responsive">
            <table class="table table-small table-bordered-right table-hover mb-0 text-nowrap border border-light">
              <thead class="bg-lighten-success">
                <tr>
                  <th class="font-weight-bold">Menu item</th>
                  <th class="font-weight-bold">URL</th>
                  <th class="font-weight-bold">Positives</th>
                  <th class="font-weight-bold">Negatives</th>
                  <th class="font-weight-bold">Meta title</th>
                  <th class="font-weight-bold">Meta description</th>
                  <th class="font-weight-bold">H1's</th>
                  <th class="font-weight-bold">H2's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_i) in compPages" :key="item_i">
                  <td class="bg-light font-weight-bold">{{item['title']}}</td>
                  <td>{{item['url']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['positives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['negatives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>{{item['meta_title']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">{{item['meta_desc']}}</td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h1']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h2']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
